import type {FC} from 'react';

import type {ButtonProps} from '@/modules/foundation/components/button';
import {CallToAction} from '@/modules/foundation/components/call-to-action/CallToAction';
import {CallToActionGroup} from '@/modules/foundation/components/call-to-action-group/CallToActionGroup';

import {linkFragmentToHref} from '../../link/query';

import type {CallToActionLineFragment} from './query';

interface Props {
	value: CallToActionLineFragment;
	className?: string;
	size?: ButtonProps['size'];
}

export const CallToActionLineContainer: FC<Props> = ({value, className, size}) => {
	return (
		<CallToActionGroup className={className}>
			{value.callToActions?.map((cta) => (
				<CallToAction
					key={cta._key}
					text={cta.text ?? ''}
					color={cta.color}
					size={size ?? 'large'}
					targetBlank={cta.targetBlank}
					href={linkFragmentToHref({
						type: cta.type,
						href: cta.href,
						_type: 'link',
						reference: cta.reference,
						targetBlank: cta.targetBlank,
					})}
				/>
			))}
		</CallToActionGroup>
	);
};
